import React from 'react'
import { IElementProps } from '../../../types/interfaces'
const HyperLink = (props: IElementProps) => {
  return (
    <div className="formGroup">
      {props.visible && (
        <div className="hyperLink">
          <a href={props.defaultValue} target="_blank">
            <i className="icon-download" />
            {props.label}
          </a>
          {props.translatedTooltip && (
            <div className="tooltipArea">
              <i className="icon-info" />
              <div className="tooltip">{props.translatedTooltip}</div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
export default HyperLink
